import {
  AccountOrganizerExternalContributionListRequestType,
  AccountOrganizerExternalContributionListResponseType,
  AccountOrganizerExternalContributionLoadRequestType,
  AccountOrganizerExternalContributionLoadResponseType,
  AccountOrganizerExternalContributionsLimitModelType,
  AccountOrganizerExternalContributionsListItemType,
  AccountOrganizerExternalContributionsModelType,
  AccountOrganizerGetExternalSupporterInfoByEmailRequestType,
  AccountOrganizerGetExternalSupporterInfoByEmailResponseType,
} from 'src/models/Account/Organizer/externalContributions';
import { APIExportStartReturnType } from 'src/models/BaseApi';
import { ApiFunctionType, httpGetCancellable, httpPost, httpPostCancellable } from 'src/utils/http';

const getPath = (path: string) => `/account/organizer/organizerExternalContributions/${path}`;

export const apiGetExternalContributions: ApiFunctionType<
  { permanentUrl: string },
  AccountOrganizerExternalContributionsModelType
> = httpGetCancellable(getPath('GetExternalContributions'));

export const apiOrganizerLoadExternalContributions = (
  data: AccountOrganizerExternalContributionListRequestType
): Promise<AccountOrganizerExternalContributionListResponseType> =>
  httpPost(getPath('loadexternalcontributions'), data);


export const apiLoadCampaignOutsideDonationLimitModel: ApiFunctionType<
  { permanentUrl: string },
  AccountOrganizerExternalContributionsLimitModelType
> = httpPostCancellable(getPath('LoadCampaignOutsideDonationLimitModel'));

export const apiExternalContributionsCsv = (permanentUrl: string): Promise<APIExportStartReturnType> =>
  httpPost(getPath('externalcontributionscsv'), { permanentUrl });

export const apiDeleteExternalContribution = (
  data: AccountOrganizerExternalContributionsListItemType
): Promise<AccountOrganizerExternalContributionsListItemType> => httpPost(getPath('deleteexternalcontribution'), data);

export const apiLoadExternalContribution = (
  data: AccountOrganizerExternalContributionLoadRequestType
): Promise<AccountOrganizerExternalContributionLoadResponseType> => httpPost(getPath('loadexternalcontribution'), data);

export const apiSaveExternalContribution = (
  data: AccountOrganizerExternalContributionLoadResponseType
): Promise<AccountOrganizerExternalContributionLoadResponseType> => httpPost(getPath('SaveExternalContribution'), data);

export const apiVerifyExternalContribution = (
  data: AccountOrganizerExternalContributionLoadResponseType
): Promise<AccountOrganizerExternalContributionLoadResponseType> =>
  httpPost(getPath('verifyexternalcontribution'), data);

export const apiCreateOrUpdateCreditCardExternalContribution = (
  data: AccountOrganizerExternalContributionLoadResponseType
): Promise<AccountOrganizerExternalContributionLoadResponseType> =>
  httpPost(getPath('createorupdatecreditcardexternalcontribution'), data);

export const apiCreateOrUpdateTestModeCreditCardExternalContribution = (
  data: AccountOrganizerExternalContributionLoadResponseType
): Promise<AccountOrganizerExternalContributionLoadResponseType> =>
  httpPost(getPath('createorupdatetestmodecreditcardexternalcontribution'), data);

export const apiCompleteCreditCardExternalContribution = (
  data: AccountOrganizerExternalContributionLoadResponseType
): Promise<AccountOrganizerExternalContributionLoadResponseType> =>
  httpPost(getPath('completecreditcardexternalcontribution'), data);

export const apiCompleteTestModeCreditCardExternalContribution = (
  data: AccountOrganizerExternalContributionLoadResponseType
): Promise<AccountOrganizerExternalContributionLoadResponseType> =>
  httpPost(getPath('completetestmodecreditcardexternalcontribution'), data);

export const apiGetExternalSupporterInfoByEmail = (
  data: AccountOrganizerGetExternalSupporterInfoByEmailRequestType
): Promise<AccountOrganizerGetExternalSupporterInfoByEmailResponseType> =>
  httpPost(getPath('getexternalsupporterinfobyemail'), data);